"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSkeleton = exports.RectangleSkeleton = exports.CircleSkeleton = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("./Skeleton.styles.scss");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Universal text skeleton that inherits font-size from parent.
 * Height is based on current line-height (1em).
 * Width is specified in em units for relative sizing.
 * Semi-transparent to work on any background.
 *
 * @example
 * <TextSkeleton width="15em" />
 * <TextSkeleton width="8em" style={{ marginLeft: '0.5em' }} />
 */
var TextSkeleton = function TextSkeleton(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '10em' : _ref$width,
      style = _ref.style;

  var skeletonStyle = _objectSpread({
    width: width
  }, style);

  return (0, _preact.h)("span", {
    "data-qa": "skeleton",
    className: "skeleton-text",
    style: skeletonStyle
  });
};

exports.TextSkeleton = TextSkeleton;

/**
 * Universal circle skeleton for avatars and icons.
 * Uses absolute pixel sizing.
 * Semi-transparent to work on any background.
 *
 * @example
 * <CircleSkeleton size={32} />
 * <CircleSkeleton size={48} style={{ marginRight: '0.5em' }} />
 */
var CircleSkeleton = function CircleSkeleton(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 24 : _ref2$size,
      style = _ref2.style;

  var skeletonStyle = _objectSpread({
    width: "".concat(size, "px"),
    height: "".concat(size, "px")
  }, style);

  return (0, _preact.h)("span", {
    "data-qa": "skeleton",
    className: "skeleton-circle",
    style: skeletonStyle
  });
};

exports.CircleSkeleton = CircleSkeleton;

/**
 * Universal rectangle skeleton for buttons, images, and blocks.
 * Flexible sizing with width/height as CSS strings.
 * Semi-transparent to work on any background.
 *
 * @example
 * <RectangleSkeleton width="62px" height="32px" />
 * <RectangleSkeleton width="100%" height="200px" />
 */
var RectangleSkeleton = function RectangleSkeleton(_ref3) {
  var _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? '100%' : _ref3$width,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? '1em' : _ref3$height,
      _ref3$borderRadius = _ref3.borderRadius,
      borderRadius = _ref3$borderRadius === void 0 ? '4px' : _ref3$borderRadius,
      style = _ref3.style;

  var skeletonStyle = _objectSpread({
    width: width,
    height: height,
    borderRadius: borderRadius
  }, style);

  return (0, _preact.h)("span", {
    "data-qa": "skeleton",
    className: "skeleton-rectangle",
    style: skeletonStyle
  });
};

exports.RectangleSkeleton = RectangleSkeleton;